var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_656_7328)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_656_7328",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0908203 0H16.0908V16H0.0908203V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_656_7328)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09082 16C10.2126 16 12.2474 15.1571 13.7477 13.6569C15.248 12.1566 16.0908 10.1217 16.0908 8C16.0908 5.87827 15.248 3.84344 13.7477 2.34315C12.2474 0.842855 10.2126 0 8.09082 0C5.96909 0 3.93426 0.842855 2.43397 2.34315C0.933675 3.84344 0.0908203 5.87827 0.0908203 8C0.0908203 10.1217 0.933675 12.1566 2.43397 13.6569C3.93426 15.1571 5.96909 16 8.09082 16ZM8.09082 14C8.87875 14 9.65897 13.8448 10.3869 13.5433C11.1149 13.2417 11.7763 12.7998 12.3335 12.2426C12.8906 11.6855 13.3326 11.0241 13.6341 10.2961C13.9356 9.56815 14.0908 8.78793 14.0908 8C14.0908 7.21207 13.9356 6.43185 13.6341 5.7039C13.3326 4.97595 12.8906 4.31451 12.3335 3.75736C11.7763 3.20021 11.1149 2.75825 10.3869 2.45672C9.65897 2.15519 8.87875 2 8.09082 2C6.49952 2 4.9734 2.63214 3.84818 3.75736C2.72296 4.88258 2.09082 6.4087 2.09082 8C2.09082 9.5913 2.72296 11.1174 3.84818 12.2426C4.9734 13.3679 6.49952 14 8.09082 14Z",
    fill: "#636363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5558 10H4.62582C4.97681 10.6083 5.48187 11.1135 6.09016 11.4646C6.69844 11.8157 7.38848 12.0004 8.09082 12C9.57082 12 10.8638 11.196 11.5558 10ZM6.09082 7C6.09082 7.26522 5.98546 7.51957 5.79793 7.70711C5.61039 7.89464 5.35604 8 5.09082 8C4.8256 8 4.57125 7.89464 4.38371 7.70711C4.19618 7.51957 4.09082 7.26522 4.09082 7C4.09082 6.73478 4.19618 6.48043 4.38371 6.29289C4.57125 6.10536 4.8256 6 5.09082 6C5.35604 6 5.61039 6.10536 5.79793 6.29289C5.98546 6.48043 6.09082 6.73478 6.09082 7ZM12.0908 7C12.0908 7.26522 11.9855 7.51957 11.7979 7.70711C11.6104 7.89464 11.356 8 11.0908 8C10.8256 8 10.5712 7.89464 10.3837 7.70711C10.1962 7.51957 10.0908 7.26522 10.0908 7C10.0908 6.73478 10.1962 6.48043 10.3837 6.29289C10.5712 6.10536 10.8256 6 11.0908 6C11.356 6 11.6104 6.10536 11.7979 6.29289C11.9855 6.48043 12.0908 6.73478 12.0908 7Z",
    fill: "#636363"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_656_7328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0908203)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.06847b8bae5b4894868476a9e82746c1.svg";
export { ForwardRef as ReactComponent };